// src/layouts/HPanelLayout.jsx
//import Sidebar from "@/components/layout/admin/Sidebar";
//import Header from "@/components/layout/admin/Header";

import React, { useState } from 'react';
import Sidebar from "../components/layout/admin/Sidebar";
import Header from "../components/layout/admin/Header";
import { Outlet } from "react-router-dom";

export default function HPanelLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleMenuToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="flex h-screen bg-#222629">
      <Sidebar isOpen={sidebarOpen} onClose={handleSidebarClose} />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuToggle={handleMenuToggle} />
        
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
